<template>
    <div>
        <div style="padding:10px 20px;height:90%;">
            <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="120px">
                <el-form-item label="栏目名称" prop="category.id">
                    <el-cascader v-model="formData.category.id"  style="width:300px;"
                    :show-all-levels="false"
                    :options="orgTree"
                    @change="handleNodeClick"
                    :props="{ value: 'id', label: 'name' }"></el-cascader>
                    <!-- <el-select v-model="formData.categoryName" placeholder="请选择" ref="selectReport" style="width:300px;">
                        <el-option :value="formData.categoryName" style="height: auto">
                            <el-tree
                            :data="orgTree"
                            :props="treeProps"
                            @node-click="handleNodeClick"
                            ></el-tree>
                        </el-option>
                    </el-select> -->
                </el-form-item>
                <el-form-item label="标题" prop="title">
                    <el-input placeholder="请输入标题" v-model="formData.title" style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="是否置顶" prop="top">
                    <el-radio v-model="formData.top" label="1">置顶</el-radio>
                    <el-radio v-model="formData.top" label="0">不置顶</el-radio>
                </el-form-item>
                <el-form-item label="发布时间" prop="publishTime">
                    <el-date-picker
                        id="picker"
                        type="date"
                        :picker-options="pickerOptions0"
                        placeholder="请选择发布时间"
                        value-format="yyyy-MM-dd"
                        v-model="formData.publishTime"
                        style="width:300px;"
                    >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="有效期" prop="expireTime">
                    <el-date-picker
                        id="picker"
                        type="date"
                        :picker-options="pickerOptions1"
                        placeholder="请选择有效期"
                        value-format="yyyy-MM-dd"
                        v-model="formData.expireTime"
                        style="width:300px;"
                    >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="发布对象" prop="publishTo">
                    <el-checkbox-group v-model="objList" @change="getPublishTo">
                        <el-checkbox label="系统用户"></el-checkbox>
                        <el-checkbox label="访客"></el-checkbox>
                        <el-checkbox label="校内网"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="发布至" prop="publishModel">
                    <el-radio v-model="formData.publishModel" :label="1" @click="formData.type = '1'">本模块</el-radio>
                    <el-radio v-model="formData.publishModel" :label="2" @click="formData.type = ''">新闻通知及本模块</el-radio>
                </el-form-item>
                <el-form-item label="发布类型" prop="type" v-if="formData.publishModel === 2">
                    <el-radio v-model="formData.type" label="1">普通通知</el-radio>
                    <el-radio v-model="formData.type" label="2">图片新闻</el-radio>
                </el-form-item>
                <el-form-item label="封面图片" prop="imageId" v-if="formData.type === '2'">
                    <div class="flex">
                        <el-upload ref="imgUpload1"
                                style="display: inline"
                                :http-request="uploadMethod"
                                :before-upload="beforeUpload"
                                :on-change="handleChange"
                                action="uploadUrl">
                                <div v-if="!imageUrl1" style="width:120px;height:120px;border:1px dashed #ddd;line-height:150px;text-align:center;">
                                    <i class="el-icon-plus" style="font-size:40px;color:#ddd;"></i>
                                </div>
                                <div v-else style="width:150px;height:150px;">
                                    <img class="w-h-100" :src="imageUrl1" alt="">
                                    <span>{{imageName}}</span>
                                </div>
                        </el-upload>
                    </div>
                </el-form-item>
                <el-form-item label="内容" prop="content">
                    <vue-tinymce
                        v-model="formData.content"
                        :setting="setting"
                    />
                    <!-- <Editor
                        ref="editor"
                        id="tinymce"
                        :init="initEditor"
                        v-model="formData.content"
                        :disabled="disabled"
                        @onChange="handlerSave"
                        @onCancel="handlerCancle"
                    /> -->
                </el-form-item>
                <el-form-item label="附件" prop="attachmentId">
                   <div class="flex">
                        <el-upload ref="upfile"
                            style="display: inline"
                            :http-request="uploadMethod2"
                            :before-upload="beforeUpload2"
                            :on-change="handleChange"
                            action="uploadUrl">
                            <el-button  type="success" icon="el-icon-folder">选择文件</el-button>
                        </el-upload>
                        <div style="margin-left:30px;">
                            <div v-for="(item, index) in fileDataList" :key="index" class="flex just-between align-center" style="width:200px;font-size:18px;">
                                <div>{{item.name + item.type}}</div>
                                <div class="el-icon-close cursor-pointer" @click="handleDelete(item)"></div>
                            </div>
                        </div>
                   </div>
                </el-form-item>
            </el-form>
            <div style="text-align:center;">
                <el-button size="small" @click="addCancle" class="queding-btn">取消</el-button>
                <!-- <el-button size="small" @click="addCancle" class="queding-btn">预览</el-button> -->
                <el-button size="small" @click="addConfirm('0')" class="queding-btn">保存</el-button>
                <el-button size="small" type="primary" @click="addConfirm('1')" class="queding-btn">发布</el-button>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable no-debugger */
/* eslint-disable prefer-const */
import tinymce from 'tinymce'
// import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver/theme.min.js'
import 'tinymce/skins/ui/oxide/skin.min.css'
import 'tinymce/icons/default/icons.min.js'
import 'tinymce/plugins/link'
import 'tinymce/plugins/code'
import 'tinymce/plugins/table'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/wordcount'
import 'tinymce/models/dom/model'
import 'tinymce/plugins/image/plugin.min.js'
import 'tinymce/plugins/media/plugin.min.js'
import 'tinymce/plugins/fullscreen/plugin.min.js'
import 'tinymce/plugins/quickbars/plugin.min.js'
import '../../../public/tinymce/plugins/indent2em/plugin.min.js'
import axios from 'axios'
export default {
    data() {
        return {
            disabled: false,
            initEditor: {},
            editFlag: false,
            imageName: '',
            objList: [],
            fileList: [],
            fileDataList: [], // 在上传文件按钮后渲染数据数组
            uploadUrl: '/admin/api/website/attachment',
            selectList: [],
            treeProps: {
                value: 'id',
                children: 'childs',
                label: 'name'
            },
            orgTree: [],
            iconList: [
                {
                    className: 'iconfalvfagui',
                    select: false
                }, {
                    className: 'iconeducation',
                    select: false
                }, {
                    className: 'iconId',
                    select: false
                }, {
                    className: 'iconxiaoxi',
                    select: false
                },
                 {
                    className: 'iconfenxiang',
                    select: false
                }, {
                    className: 'iconyibiaoban',
                    select: false
                }, {
                    className: 'iconline_shuxie',
                    select: false
                }, {
                    className: 'iconmenu_bszn',
                    select: false
                }],
            addDialog: false,
            addFlag: true,
            total: 0,
            selectName: '',
            imageUrl: '',
            options: [
                {
                    label: '123',
                    value: 1
                }
            ],
            dataList: [],
            pageData: {
                pageSize: 10,
                pageNumber: 1
            },
            formData: {
                categoryName: '',
                category: {
                    id: ''
                },
                top: '',
                title: '',
                publishTime: '',
                expireTime: '',
                publishTo: [],
                type: '1',
                content: '',
                attachmentId: '',
                imageId: '',
                status: '',
                publishModel: 1
            },
            rules: {
                'category.id': [{ required: true, message: '请选择栏目名称', trigger: 'blur' }],
                top: [{ required: true, message: '请选择是否置', trigger: 'blur' }],
                title: [{ required: true, message: '请输入标题', trigger: 'change' }],
                publishTime: [{ required: true, message: '请选择发布时间', trigger: 'blur' }],
                publishTo: [{ required: true, message: '请选择发布对象', trigger: 'blur' }],
                type: [{ required: true, message: '请选择发布类型', trigger: 'blur' }],
                // imageId: [{ required: true, message: '请上传封面图片', trigger: 'blur' }],
                content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
                publishModel: [{ required: true, message: '请选择发布模块', trigger: 'blur' }]
            },
            headerMsg: {},
            imageUrl1: '',
            setting: {
                menubar: false,
                toolbar: "indent2em | undo redo | fullscreen | formatselect alignleft aligncenter alignright alignjustify | numlist bullist | fontselect fontsizeselect forecolor backcolor | bold italic underline strikethrough | indent outdent | superscript subscript | removeformat |",
                toolbar_drawer: "sliding",
                quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
                plugins: "link image media table indent2em lists fullscreen quickbars",
                language_url: require('@/assets/langs/zh_CN.js'),
                language: 'zh_CN', // 本地化设置
                height: 350
            },
            pickerOptions0: {
                disabledDate: (time) => {
                    if (this.formData.expireTime) {
                        return time.getTime() > new Date(this.formData.expireTime).getTime();
                    }
                }
            },
            pickerOptions1: {
                disabledDate: (time) => {
                    if (this.formData.publishTime) {
                      return time.getTime() < new Date(this.formData.publishTime).getTime();
                    }
                }
            },
        }
    },
    methods: {
        setup () {
             this.editorInit = {
                selector: '#tinymce',
                language_url: require('@/assets/langs/zh_CN.js'),
                language: 'zh_CN',
                skin_url: '../../../public/tinymce/skins/ui/oxide',
                height: 300,
                plugins: 'link lists image code table wordcount',
                toolbar: 'bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | removeformat',
                statusbar: true, // 底部的状态栏
                menubar: true, // 最上方的菜单
                branding: false // 水印“Powered by TinyMCE”
            }
        },
        handlerSave () {},
        handlerCancle () {},
        // 通过onchanne触发方法获得文件列表
        handleChange(file, fileList) {
            this.fileList = fileList
        },
        handleDelete (data) {
            const index = this.fileDataList.findIndex(item => item.id === data.id)
            this.fileDataList.splice(index, 1)
        },
        handleNodeClick (data) {
            console.log(data)
            this.formData.category.id = data[data.length - 1]
        },
        getPublishTo (data) {
            this.formData.publishTo = ''
            data.forEach(item => {
                if (item === '系统用户') {
                    if (this.formData.publishTo) {
                        this.formData.publishTo = this.formData.publishTo + ',' + '1'
                    } else {
                        this.formData.publishTo = '1'
                    }
                }
                if (item === '访客') {
                    if (this.formData.publishTo) {
                        this.formData.publishTo = this.formData.publishTo + ',' + '2'
                    } else {
                        this.formData.publishTo = '2'
                    }
                }
                if (item === '校内网') {
                    if (this.formData.publishTo) {
                        this.formData.publishTo = this.formData.publishTo + ',' + '3'
                    } else {
                        this.formData.publishTo = '3'
                    }
                }
            })
        },
        changeSelect () {
            this.$forceUpdate()
        },
        getTreeList () {
            this.$api.publish.getItemTree().then(res => {
                if (res.code === 200) {
                    this.orgTree = res.data
                    console.log(this.orgTree)
                }
            })
        },
        addCancle () {
            this.$router.go(-1)
        },
        addConfirm (status) {
            this.formData.status = status
            this.formData.attachmentId = ''
            this.fileDataList.forEach(item => {
                if (this.formData.attachmentId) {
                    this.formData.attachmentId = this.formData.attachmentId + ',' + item.id
                } else {
                    this.formData.attachmentId = item.id
                }
            })
            // this.formData.category = { id: this.formData.categoryName[this.formData.categoryName.length - 1] }
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    console.log(this.formData)
                    if (!this.editFlag) {
                        this.$api.publish.addNotice(this.formData).then(res => {
                            if (res.code === 200) {
                                this.$message.success(status === '1' ? '发布成功' : '保存成功')
                                this.$router.go(-1)
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    } else {
                        this.$api.publish.editNotice(this.formData).then(res => {
                            if (res.code === 200) {
                                this.$message.success(status === '1' ? '发布成功' : '保存成功')
                                this.$router.go(-1)
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    }
                }
            })
        },
        imgSuccess (data) {
            console('success')
            console.log(data)
        },
        imgRemove () {},
        uploadMethod1 (obj) {
            let fd = new FormData()
            fd.append('file', obj.file)
            this.$api.imageConfig.imageUpload(fd).then((res) => {
                if (res.code === 200) {
                    this.$refs.imgUpload1.clearFiles()
                    this.formData.logoId = res.data.id
                    this.imageUrl1 = res.data.url
                    this.imageName1 = res.data.name + res.data.type
                    this.$message({
                        type: 'success',
                        message: '上传成功'
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            })
        },
        uploadMethod (obj) {
            let fd = new FormData()
            fd.append('file', obj.file)
            this.$api.imageConfig.imageUpload(fd).then(res => {
                if (res.code === 200) {
                    this.imageUrl1 = res.data.url
                    this.formData.imageId = res.data.id
                    this.imageName = res.data.name + res.data.type
                    this.$message({
                        type: 'success',
                        message: '上传成功'
                    })
                    this.$refs.imgUpload.clearFiles()
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            })
            // axios.post(this.uploadUrl, fd, {
            //     headers: {
            //         token: localStorage.getItem('token')
            //     }
            // }).then((res) => {
            //     if (res.data.code === 200) {
            //         this.formData.imageId = res.data.data.id
            //         this.imageName = res.data.data.name + res.data.data.type
            //         this.$message({
            //             type: 'success',
            //             message: '上传成功'
            //         })
            //         this.$refs.imgUpload.clearFiles()
            //     } else {
            //         this.$message({
            //             type: 'error',
            //             message: res.message
            //         })
            //     }
            // })
        },
        uploadMethod2 (obj) {
            let fd = new FormData()
            fd.append('file', obj.file)
            this.$api.imageConfig.imageUpload(fd).then(res => {
                if (res.code === 200) {
                    this.fileDataList.push(res.data)
                    this.$message({
                        type: 'success',
                        message: '上传成功'
                    })
                    this.$refs.upfile.clearFiles()
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            })
            // axios.post(this.uploadUrl, fd, {
            //     headers: {
            //         token: localStorage.getItem('token')
            //     }
            // }).then((res) => {
            //     if (res.data.code === 200) {
            //         this.fileDataList.push(res.data.data)
            //         this.$message({
            //             type: 'success',
            //             message: '上传成功'
            //         })
            //         this.$refs.upfile.clearFiles()
            //     } else {
            //         this.$message({
            //             type: 'error',
            //             message: res.message
            //         })
            //     }
            // })
        },
        handlePreview (data) {
            console.log(data)
        },
        onEditorBlur () {},
        onEditorFocus () {},
        onEditorReady () {},
        onEditorChange () {},
        getNoticeInfo () {
            const param = {
                id: this.$route.params.id
            }
            this.$api.publish.getNoticeInfo(param).then(res => {
                if (res.code === 200) {
                    if (res.data.top === 0) {
                        res.data.top = '0'
                    } else {
                        res.data.top = '1'
                    }
                    if (res.data.imageFile && res.data.imageFile.name && res.data.imageFile.type) {
                        this.imageName = res.data.imageFile.name + res.data.imageFile.type
                        this.imageUrl1 = res.data.imageFile.url
                    }
                    this.formData = res.data
                    this.formData.categoryName = res.data.category.name
                    if (res.data.attachments) {
                        this.fileDataList = res.data.attachments
                    }
                    if (res.data.publishTo) {
                        if (res.data.publishTo.indexOf("1") !== -1) {
                            this.objList.push('系统用户')
                        }
                        if (res.data.publishTo.indexOf("2") !== -1) {
                            this.objList.push('访客')
                        }
                        if (res.data.publishTo.indexOf("3") !== -1) {
                            this.objList.push('校内网')
                        }
                    }
                }
            })
        },
        beforeUpload (file) {
            if (file.type?.indexOf("image") === -1) {
                this.$message.error("请上传jpg/jpeg/png格式的图片");
                return false;
            }
            const isOutSize = file.size / 1024 / 1024 < 20
            if (!isOutSize) {
                this.$message.warning('上传文件大小不能超过 20MB!');
                return false;
            }
        },
        beforeUpload2 (file) {
            const isOutSize = file.size / 1024 / 1024 < 20
            if (!isOutSize) {
                this.$message.warning('上传文件大小不能超过 20MB!');
                return false;
            }
        },
    },
    created() {
        this.getTreeList()
        if (this.$route.params.id) {
            this.getNoticeInfo()
            this.editFlag = true
        }
        // tinymce.init(this.editorInit)
        console.log(this.$route.params)
    },
}
</script>

<style scoped lang='less'>
/deep/ .icon-class .el-form-item__content {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
/deep/ .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    background-color: #fff !important;
}
</style>
